import { LEVEL_COLOURS } from "../data/teams";

export function LevelBadge({ level }) {
  const c = LEVEL_COLOURS[level] || { bg: "#f3f4f6", text: "#374151", dot: "#9ca3af" };
  return (
    <span style={{
      background: c.bg, color: c.text, borderRadius: 20, padding: "3px 10px",
      fontSize: 11, fontWeight: 700, letterSpacing: 0.5,
      display: "inline-flex", alignItems: "center", gap: 5
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: c.dot, display: "inline-block" }} />
      {level.toUpperCase()}
    </span>
  );
}

export function DivisionBadge({ division }) {
  const colours = {
    "Premier Division": "#7c3aed",
    "Division 1": "#0369a1",
    "Division 2": "#0f766e",
    "Division 3": "#4b5563",
  };
  return (
    <span style={{
      background: colours[division] || "#374151", color: "#fff",
      borderRadius: 20, padding: "3px 10px", fontSize: 11, fontWeight: 700, letterSpacing: 0.5
    }}>
      {division}
    </span>
  );
}
